import { Icon } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { space, colors, mediaQueries } from 'style/config';
import HelperUtils from 'utils/Helpers';
import UI from 'utils/UI';
import { PROACTIVE_CHAT } from 'constants/chat';
import LanguageLocale from 'utils/LanguageLocale';

const ProactiveGreeting = ({ action, onApplyCampaign, onClose }) => {
    const message =
        UI.isSMUI() || LanguageLocale.isFRCanada()
            ? action.content.message
            : HelperUtils.truncateText(action.content.message, PROACTIVE_CHAT.truncateTextLength);

    return (
        <div css={styles.campaignBlock}>
            <div
                css={styles.campaignMessage}
                onClick={onApplyCampaign}
            >
                {message}
            </div>
            <a
                css={styles.closeIcon}
                onClick={onClose}
            >
                <Icon
                    name='x'
                    size={14}
                />
            </a>
        </div>
    );
};

const styles = {
    campaignBlock: {
        backgroundColor: colors.black,
        display: 'flex',
        borderRadius: space[1],
        background: colors.black,
        padding: space[2],
        minHeight: 40,
        maxWidth: '70vw',
        marginLeft: space[2],
        [mediaQueries.xsMax]: {
            maxWidth: '100%',
            minHeight: space[7]
        }
    },
    campaignMessage: {
        marginRight: space[2],
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        height: 'auto',
        color: colors.white,
        fontWeight: 'normal',
        flex: 1
    },
    closeIcon: {
        cursor: 'pointer',
        color: colors.white,
        padding: `0 ${space[1]}px`
    }
};

export default wrapFunctionalComponent(ProactiveGreeting, 'ProactiveGreeting');
